import {Component, computed, inject, input} from "@angular/core";
import {StripHtmlPipe} from "../../shared-pipes/strip-html.pipe";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
	selector: "sim-safe-html",
	template: `<span [innerHTML]="__html()"></span>`,
	styles: `
		:host {
			display: inline;
		}
	`,
	providers: [StripHtmlPipe],
})
export class SafeHtmlComponent {
	private _sanitizer = inject(DomSanitizer);
	private _stripHtmlPipe = inject(StripHtmlPipe);

	public html = input.required<string>();

	protected __html = computed<SafeHtml>(() => {
		const stripped = this._stripHtmlPipe.transform(this.html());
		return this._sanitizer.bypassSecurityTrustHtml(stripped);
	});
}
